export default __webpack_public_path__ + "static/media/lamar-logo-small.47523d52.png";